angular.module("rental")
    .factory("RentalAgreementItem", function ($resource) {
        return $resource("/crm/api/rental-agreement-item/:id", {id: "@id"}, {
            table: {method: 'GET', isArray: false, url: '/crm/api/rental-agreement-item/table'},
            tableStatistics: {method: 'GET', isArray: false, url: '/crm/api/rental-agreement-item/table-statistics'},
            update: {method: 'PUT'},
            remove: {method: 'DELETE'},
        });
    })
    .component('rentalAgreementItemTypeLabel', {
        bindings: {
            type: '<'
        },
        template: `<span class="label label-default rental-agreement-item-type-label {{$ctrl.type}}">{{ 'rental-agreement.item.type.' + $ctrl.type | translate }}</span>`
    })
    .service('RentalAgreementItemService', function (modals, $rootScope, RentalAgreementItem, RentalAgreementConst) {

    })
    .component("rentalAgreementItemList", {
        bindings: {
            page: "<",
            filters: "<",
            statistics: "<"
        },
        templateUrl: "app/rental/agreement-item/list.html",
        controller: function ($scope, $state, $stateParams, $httpParamSerializer, RentalAgreementConst, RentalAgreementService, RentalAgreementItemService, RentalResourceService) {
            this.reset = () => this.filters = {filter: this.filters.filter}
            this.RentalAgreementItemService = RentalAgreementItemService
            this.RentalAgreementService = RentalAgreementService
            this.RentalResourceService = RentalResourceService

            this.isBeforeNow = (date) => {
                return moment(date).isBefore(moment())
            }
            this.getExportUrl = () => {
                return "/crm/api/rental-agreement-item-batch/export?" + $httpParamSerializer($stateParams)
            }
            $scope.$on(RentalAgreementConst.eventUpdate, () => $state.reload())
        }
    })
    .config(function ($stateProvider, RentalAgreementConst) {
        $stateProvider.state('rentalAgreementItemList', {
            parent: 'app',
            url: '/rental-agreement-item?{page:int}&{size:int}&{sort:string}&{search:string}&type&termsAtDate&indexation',
            data: {
                authorities: [RentalAgreementConst.RoleAgreementRead]
            },
            params: {
                status: {array: true, value: [], squash: false},
            },
            views: {
                'content@': 'rentalAgreementItemList'
            },
            resolve: {
                filters: $stateParams => angular.copy($stateParams),
                page: (RentalAgreementItem, $stateParams) => RentalAgreementItem.table(angular.copy($stateParams)).$promise,
                statistics: (RentalAgreementItem, $stateParams) => RentalAgreementItem.tableStatistics(angular.copy($stateParams)).$promise,
            }
        })
    })
